import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nav-tooltip-how-it-works',
  templateUrl: './nav-tooltip-how-it-works.component.html',
  styleUrls: ['./nav-tooltip-how-it-works.component.scss'],
})
export class NavTooltipHowItWorksComponent {
  language!: string;
  langChangeSubscription: Subscription;
  @Output() closeTooltip = new EventEmitter<boolean>();

  // Configuración de posiciones por idioma
  get tooltipArrowPositionHow() {
    const positions: { [key: string]: string } = {
      es: '450px', // Español
      en: '395px', // Inglés
    };
    return positions[this.language] || '450px';
  }

  constructor(
    private translateService: TranslateService,
    public router: Router
  ) {
    this.language = this.translateService.currentLang;
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event) => {
        this.language = event.lang;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  goNavigateToUrlService(url: string) {
    const customCreateUrl = `/${this.language}/como-funciona/${url}`;
    this.router.navigate([customCreateUrl]);
    this.closeTooltip.emit(false);
  }
}
